<template>
  <div class="reksadana">
    <Header />
    <div class="reksadana-page">
      <b-container fluid class="reksadana-container">
        <b-row>
          <div class="col-lg-2 col-md-6 filter-collumn">
            <div class="filter-title">
              <h1><b-icon class="mr-2" icon="filter"></b-icon>Filter</h1>
            </div>
            <div class="filter-fund-type my-4">
              <h2>Jenis</h2>

              <b-form-select
                v-model="filterFundType"
                :options="fundTypeOptions"
                @change="filterType($event)"
              >
                <template #first>
                  <b-form-select-option :value="null" disabled
                    >Pilih Jenis</b-form-select-option
                  >
                </template>
              </b-form-select>
            </div>

            <div class="filter-investment-manager mb-4">
              <h2>Manager Investasi</h2>
              <b-form-select
                v-model="filterInvestmentManager"
                :options="investmentManagerOptions"
                @change="filterMi($event)"
              >
                <template #first>
                  <b-form-select-option :value="null" disabled
                    >Pilih Manager Investasi</b-form-select-option
                  >
                </template>
              </b-form-select>
            </div>
            <div class="filter-risk-profile mb-4">
              <h2>Profil Resiko</h2>
              <b-form-select
                v-model="filterRiskProfile"
                :options="riskProfileOptions"
                @change="filterRisk($event)"
              >
                <template #first>
                  <b-form-select-option :value="null" disabled
                    >Pilih Profil Resiko</b-form-select-option
                  >
                </template>
              </b-form-select>
            </div>
            <div class="filter-sharia mb-4">
              <vs-checkbox id="sharia" v-model="is_sharia" name="sharia"
                >Produk Syariah
              </vs-checkbox>
            </div>

            <b-button block class="btn-tertiary py-2 mb-3" @click="filterClick"
              >Filter</b-button
            >
            <b-button
              block
              class="btn-show py-2"
              :disabled="!disabled"
              @click="reloadPage"
              >Reset</b-button
            >
          </div>

          <div class="col-lg-10 col-md-6 product-collumn">
            <b-row>
              <div class="col-lg-8 col-md-6 my-auto">
                <div class="list-product-title">
                  <b-skeleton-wrapper :loading="loading">
                    <template #loading>
                      <b-skeleton width="100%"></b-skeleton>
                    </template>
                    <h1>
                      Pilih Produk Reksadana
                      <span
                        >Performa NAV per tanggal
                        {{ moment(navPerformanceDate).format(" DD MMM YYYY") }}
                      </span>
                    </h1>
                  </b-skeleton-wrapper>
                </div>
              </div>

              <div class="col-lg-4 col-md-6 my-auto">
                <b-skeleton-wrapper :loading="loading">
                  <template #loading>
                    <b-skeleton width="100%"></b-skeleton>
                  </template>
                  <b-row class="justify-content-end search-form-row">
                    <div class="search-form text-right">
                      <b-form inline>
                        <div class="search-form-card">
                          <b-card>
                            <b-icon
                              class="text-muted mx-2 search-icon"
                              icon="search"
                            ></b-icon>
                            <b-form-input
                              class="my-auto"
                              v-model="filter"
                              type="search"
                              id="filterInput"
                              placeholder="Search"
                            ></b-form-input>
                          </b-card>
                        </div>
                      </b-form>
                    </div>
                  </b-row>
                </b-skeleton-wrapper>
              </div>
            </b-row>

            <b-skeleton-wrapper :loading="loading">
              <template #loading>
                <div class="my-4">
                  <b-skeleton-table
                    :rows="5"
                    :columns="8"
                    :table-props="{ bordered: true, striped: true }"
                  ></b-skeleton-table>
                </div>
              </template>
              <b-row>
                <template>
                  <div class="table-responsive table-product">
                    <b-table
                      responsive
                      id="reksadana"
                      striped
                      hover
                      outlined
                      :items="products"
                      :filter="filter"
                      :fields="fields"
                      :per-page="perPage"
                      :sort-by.sync="sortBy"
                      :sort-desc.sync="sortDesc"
                      :current-page="currentPage"
                      sticky-header="80vh"
                    >
                      <template v-slot:head(navOneday)="data">
                        <div style="width: 100px">
                          <span>{{ data.label }}</span>
                        </div>
                      </template>

                      <template v-slot:head(navOneMonth)="data">
                        <div style="width: 100px">
                          <span>{{ data.label }}</span>
                        </div>
                      </template>

                      <template v-slot:head(navOneYear)="data">
                        <div style="width: 100px">
                          <span>{{ data.label }}</span>
                        </div>
                      </template>

                      <template v-slot:head(navYtd)="data">
                        <div style="width: 100px">
                          <span>{{ data.label }}</span>
                        </div>
                      </template>

                      <template v-slot:head(navThreeYear)="data">
                        <div style="width: 100px">
                          <span>{{ data.label }}</span>
                        </div>
                      </template>

                      <template v-slot:head(navFiveYear)="data">
                        <div style="width: 100px">
                          <span>{{ data.label }}</span>
                        </div>
                      </template>

                      <template v-slot:cell(fund_name)="data">
                        <div class="row">
                          <td class="noborder" style="width: 300px">
                            <router-link
                              :to="
                                '/subscription-product-detail/' +
                                data.item.fund_code +
                                '/' +
                                data.item.id +
                                '/' +
                                data.item.fund_name
                              "
                              >{{ data.item.fund_name }}</router-link
                            >
                            <p class="d-none d-lg-block">
                              {{ data.item.im_name }}
                            </p>
                          </td>
                        </div>
                      </template>

                      <template v-slot:cell(fund_type)="data">
                        <div class="row">
                          <td class="noborder" style="width: 160px">
                            {{ data.item.fund_type }}
                          </td>
                        </div>
                      </template>

                      <template v-slot:cell(nav_per_unit)="data">
                        <div class="row">
                          <td class="noborder" style="width: 120px">
                            {{ formatNab(data.item.nav_per_unit) }}
                          </td>
                        </div>
                      </template>

                      <template v-slot:cell(navAum)="data">
                        <div class="row">
                          <td class="noborder" style="width: 200px">
                            {{ formatPrice(data.item.navAum) }}
                          </td>
                        </div>
                      </template>

                      <template v-slot:cell(navOneday)="data">
                        <div class="row">
                          <td
                            style="width: 100px"
                            class="text-left noborder"
                            :class="{
                              'text-success': data.item.navOneday >= 0,
                              'text-danger': data.item.navOneday < 0,
                            }"
                          >
                            <template v-if="data.item.navOneday >= 0">
                              <b-icon icon="caret-up-fill"> </b-icon>
                            </template>
                            <template v-else>
                              <b-icon icon="caret-down-fill"> </b-icon>
                            </template>
                            {{ data.item.navOneday | formatPercent }}
                          </td>
                        </div>
                      </template>

                      <template v-slot:cell(navOneMonth)="data">
                        <div class="row">
                          <td
                            style="width: 100px"
                            class="text-left noborder"
                            :class="{
                              'text-success': data.item.navOneMonth >= 0,
                              'text-danger': data.item.navOneMonth < 0,
                            }"
                          >
                            <template v-if="data.item.navOneMonth >= 0">
                              <b-icon icon="caret-up-fill"> </b-icon>
                            </template>
                            <template v-else>
                              <b-icon icon="caret-down-fill"> </b-icon>
                            </template>
                            {{ data.item.navOneMonth | formatPercent }}
                          </td>
                        </div>
                      </template>

                      <template v-slot:cell(navOneYear)="data">
                        <div class="row">
                          <td
                            style="width: 100px"
                            class="text-left noborder"
                            :class="{
                              'text-success': data.item.navOneYear >= 0,
                              'text-danger': data.item.navOneYear < 0,
                            }"
                          >
                            <template v-if="data.item.navOneYear >= 0">
                              <b-icon icon="caret-up-fill"> </b-icon>
                            </template>
                            <template v-else>
                              <b-icon icon="caret-down-fill"> </b-icon>
                            </template>
                            {{ data.item.navOneYear | formatPercent }}
                          </td>
                        </div>
                      </template>

                      <template v-slot:cell(navYtd)="data">
                        <div class="row">
                          <td
                            style="width: 100px"
                            class="text-left noborder"
                            :class="{
                              'text-success': data.item.navYtd >= 0,
                              'text-danger': data.item.navYtd < 0,
                            }"
                          >
                            <template v-if="data.item.navYtd >= 0">
                              <b-icon icon="caret-up-fill"> </b-icon>
                            </template>
                            <template v-else>
                              <b-icon icon="caret-down-fill"> </b-icon>
                            </template>
                            {{ data.item.navYtd | formatPercent }}
                          </td>
                        </div>
                      </template>

                      <template v-slot:cell(navThreeYear)="data">
                        <div class="row">
                          <td
                            style="width: 100px"
                            class="text-left noborder"
                            :class="{
                              'text-success': data.item.navThreeYear >= 0,
                              'text-danger': data.item.navThreeYear < 0,
                            }"
                          >
                            <template v-if="data.item.navThreeYear >= 0">
                              <b-icon icon="caret-up-fill"> </b-icon>
                            </template>
                            <template v-else>
                              <b-icon icon="caret-down-fill"> </b-icon>
                            </template>
                            {{ data.item.navThreeYear | formatPercent }}
                          </td>
                        </div>
                      </template>

                      <template v-slot:cell(navFiveYear)="data">
                        <div class="row">
                          <td
                            style="width: 100px"
                            class="text-left noborder"
                            :class="{
                              'text-success': data.item.navFiveYear >= 0,
                              'text-danger': data.item.navFiveYear < 0,
                            }"
                          >
                            <template v-if="data.item.navFiveYear >= 0">
                              <b-icon icon="caret-up-fill"> </b-icon>
                            </template>
                            <template v-else>
                              <b-icon icon="caret-down-fill"> </b-icon>
                            </template>
                            {{ data.item.navFiveYear | formatPercent }}
                          </td>
                        </div>
                      </template>

                      <template v-slot:cell(actions)="data">
                        <div class="row">
                          <td style="border: none">
                            <router-link
                              :to="
                                '/subscription-product-detail/' +
                                data.item.fund_code +
                                '/' +
                                data.item.id +
                                '/' +
                                data.item.fundNameFormatted
                              "
                              class="
                                btn-primary
                                px-4
                                py-2
                                noborder
                                inline-block
                              "
                              >Beli
                            </router-link>
                          </td>
                        </div>
                      </template>
                    </b-table>

                    <b-pagination
                      v-model="currentPage"
                      :total-rows="rows"
                      :per-page="perPage"
                      aria-controls="table-product"
                      class="customPagination"
                    ></b-pagination>
                  </div>
                </template>
                <div class="disclaimer">
                  <b-row class="justify-content-center mb-4">
                    <div class="col-lg-12 col-md-6">
                      <div class="card p-1">
                        <div class="card-body">
                          <div class="row">
                            <div class="col-lg-12 col-md-6 d-flex">
                              <div class="align-items-center">
                                <img
                                  src="@/assets/img/icons/information/information-ic.svg"
                                  alt="Disclaimer"
                                  class="mr-2"
                                />
                              </div>
                              <p>
                                Kinerja Reksa dana yang ditampilkan pada halaman
                                ini merupakan kinerja historis masa lalu, dan
                                tidak mencerminkan kepastian kinerja di masa
                                yang akan datang.
                              </p>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </b-row>
                </div>
              </b-row>
            </b-skeleton-wrapper>
          </div>
        </b-row>
      </b-container>
    </div>
  </div>
</template>

<script>
import Header from "@/components/partials/header/Header.vue";
import axios from "axios";

export default {
  name: "Reksadana",
  metaInfo: {
    title: "Reksadana | Invesnow.id",
  },
  components: {
    Header,
  },
  created() {
    this.fetchFunds();
    this.fetchMi();
    this.$_loadingTimeInterval = null;
  },
  data() {
    return {
      products: [],
      product: [],
      navPerformanceDate: "",
      filterFundType: null,
      loading: false,
      loadingTime: 0,
      maxLoadingTime: 4,
      sortBy: "navOneYear",
      sortDesc: true,
      disabled: false,
      fields: [
        {
          key: "fund_name",
          label: "Reksa Dana",
          sortable: true,
        },
        {
          key: "actions",
          label: "",
          sortable: false,
        },
        {
          key: "fund_type",
          label: "Jenis",
          sortable: true,
        },
        {
          key: "nav_per_unit",
          label: "NAV/UP",
          sortable: true,
        },
        {
          key: "navAum",
          label: "Dana Kelolaan",
          sortable: true,
        },
        {
          key: "navOneday",
          label: "1 hr (%)",
          sortable: true,
        },
        {
          key: "navOneMonth",
          label: "1 bln (%)",
          sortable: true,
        },
        {
          key: "navOneYear",
          label: "1 thn (%)",
          sortable: true,
        },
        {
          key: "navYtd",
          label: "YTD (%)",
          sortable: true,
        },
        {
          key: "navThreeYear",
          label: "3 thn (%)",
          sortable: true,
        },
        {
          key: "navFiveYear",
          label: "5 thn (%)",
          sortable: true,
        },
      ],
      filter: "",
      perPage: 10,
      currentPage: 1,
      fundTypeOptions: [
        { value: "pasar_uang", text: "Reksa Dana Pasar Uang" },
        { value: "pendapatan_tetap", text: "Reksa Dana Pendapatan Tetap" },
        { value: "saham", text: "Reksa Dana Saham" },
        { value: "campuran", text: "Reksa Dana Campuran" },
        { value: "terproteksi", text: "Reksa Dana Terproteksi" },
      ],
      filterInvestmentManager: null,
      investmentManagerOptions: [],
      data_mi: [],
      filterRiskProfile: null,
      riskProfileOptions: [
        { value: "konservatif", text: "Konservatif" },
        { value: "moderat", text: "Moderat" },
        { value: "agresif", text: "Agresif" },
      ],
      filterArr: [
        { type: "type", value: null },
        { type: "mi", value: null },
        { type: "risk", value: null },
      ],
      is_sharia: false,
      product_im: [],
      product_risk: [],
      product_type: [],
    };
  },

  computed: {
    rows() {
      return this.products.length;
    },
    fundNameFormatted() {
      return this.products.fund_name.replace(/\s+/g, "-");
    },
  },
  watch: {
    loading(newValue, oldValue) {
      if (newValue !== oldValue) {
        this.clearLoadingTimeInterval();

        if (newValue) {
          this.$_loadingTimeInterval = setInterval(() => {
            this.loadingTime++;
          }, 1000);
        }
      }
    },
    loadingTime(newValue, oldValue) {
      if (newValue !== oldValue) {
        if (newValue === this.maxLoadingTime) {
          this.loading = false;
        }
      }
    },
  },
  methods: {
    reloadPage() {
      window.location.reload();
    },
    clearLoadingTimeInterval() {
      clearInterval(this.$_loadingTimeInterval);
      this.$_loadingTimeInterval = null;
    },
    async fetchFunds() {
      this.loading = true;
      let response = await axios({
        method: "GET",
        url: "3041?api=1&type=1",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
          Authorization: `${this.bearer_token}`,
        },
      });
      this.products = response.data.dataNav;
      this.navPerformanceDate = response.data.nav_date;
    },

    async fetchMi() {
      let response = await axios({
        method: "GET",
        url: "mi",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
        },
      });
      this.data_mi = response.data.data;

      this.data_mi.map((data) => {
        this.investmentManagerOptions.push({
          value: data.id,
          text: data.im_name,
        });
      });
    },

    filterType(event) {
      this.is_type = event.toLowerCase();
    },

    filterRisk(event) {
      this.is_risk = event.toLowerCase();
    },
    filterMi(event) {
      this.is_im = event;
    },

    async filterClick() {
      this.products = [];
      if (
        this.is_sharia == false &&
        this.is_type != null &&
        this.is_risk == null &&
        this.is_im == null
      ) {
        this.loading = true;
        let response = await axios({
          method: "GET",
          url: "3041?api=1&type=1&is_type=" + this.is_type,
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
          },
        });
        response.data.map((data) => {
          return this.products.push(data);
        });
      } else if (
        this.is_sharia == false &&
        this.is_type != null &&
        this.is_risk != null &&
        this.is_im == null
      ) {
        this.loading = true;
        let response = await axios({
          method: "GET",
          url:
            "3041?api=1&type=1&is_type=" +
            this.is_type +
            "&is_risk=" +
            this.is_risk,
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
          },
        });
        response.data.map((data) => {
          return this.products.push(data);
        });
        // this.is_risk = null;
      } else if (
        this.is_sharia == false &&
        this.is_im != null &&
        this.is_risk == null &&
        this.is_type == null
      ) {
        this.loading = true;
        let response = await axios({
          method: "GET",
          url: "3041?api=1&type=1&im_id=" + this.is_im,
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
          },
        });
        response.data.map((data) => {
          return this.products.push(data);
        });
      } else if (
        this.is_sharia == false &&
        this.is_im != null &&
        this.is_risk != null &&
        this.is_type == null
      ) {
        this.loading = true;
        let response = await axios({
          method: "GET",
          url:
            "3041?api=1&type=1&im_id=" +
            this.is_im +
            "&is_risk=" +
            this.is_risk,
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
          },
        });
        response.data.map((data) => {
          return this.products.push(data);
        });
      } else if (
        this.is_sharia == true &&
        this.is_im != null &&
        this.is_risk == null &&
        this.is_type == null
      ) {
        this.loading = true;
        let response = await axios({
          method: "GET",
          url: "3041?api=1&type=1&im_id=" + this.is_im + "&is_sharia=1",
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
          },
        });
        response.data.map((data) => {
          return this.products.push(data);
        });
      } else if (
        this.is_sharia == false &&
        this.is_risk != null &&
        this.is_im == null &&
        this.is_type == null
      ) {
        this.loading = true;
        let response = await axios({
          method: "GET",
          url: "3041?api=1&type=1&is_risk=" + this.is_risk,
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
          },
        });
        response.data.map((data) => {
          return this.products.push(data);
        });
      } else if (
        this.is_sharia == false &&
        this.is_im != null &&
        this.is_risk != null &&
        this.is_type != null
      ) {
        this.loading = true;
        let response = await axios({
          method: "GET",
          url:
            "3041?api=1&type=1&im_id=" +
            this.is_im +
            "&is_risk=" +
            this.is_risk +
            "&is_type=" +
            this.is_type,
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
          },
        });
        response.data.map((data) => {
          return this.products.push(data);
        });
      } else if (
        this.is_sharia == true &&
        this.is_im != null &&
        this.is_risk == null &&
        this.is_type != null
      ) {
        this.loading = true;
        let response = await axios({
          method: "GET",
          url:
            "3041?api=1&type=1&im_id=" +
            this.is_im +
            "&is_type=" +
            this.is_type +
            "&is_sharia=1",
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
          },
        });
        response.data.map((data) => {
          return this.products.push(data);
        });
      } else if (
        this.is_sharia == true &&
        this.is_im == null &&
        this.is_risk != null &&
        this.is_type != null
      ) {
        this.loading = true;
        let response = await axios({
          method: "GET",
          url:
            "3041?api=1&type=1&is_risk=" +
            this.is_risk +
            "&is_type=" +
            this.is_type +
            "&is_sharia=1",
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
          },
        });
        response.data.map((data) => {
          return this.products.push(data);
        });
      } else if (
        this.is_sharia == true &&
        this.is_im != null &&
        this.is_risk != null &&
        this.is_type == null
      ) {
        this.loading = true;
        let response = await axios({
          method: "GET",
          url:
            "3041?api=1&type=1&is_risk=" +
            this.is_risk +
            "&im_id=" +
            this.is_im +
            "&is_sharia=1",
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
          },
        });
        response.data.map((data) => {
          return this.products.push(data);
        });
      } else if (
        this.is_sharia == true &&
        this.is_im != null &&
        this.is_risk != null &&
        this.is_type != null
      ) {
        this.loading = true;
        let response = await axios({
          method: "GET",
          url:
            "3041?api=1&type=1&im_id=" +
            this.is_im +
            "&is_risk=" +
            this.is_risk +
            "&is_type=" +
            this.is_type +
            "&is_sharia=1",
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
          },
        });
        response.data.map((data) => {
          return this.products.push(data);
        });
      } else if (
        this.is_sharia == true &&
        this.is_im == null &&
        this.is_risk != null &&
        this.is_type == null
      ) {
        this.loading = true;
        let response = await axios({
          method: "GET",
          url: "3041?api=1&type=1&is_risk=" + this.is_risk + "&is_sharia=1",
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
          },
        });
        response.data.map((data) => {
          return this.products.push(data);
        });
      } else if (this.is_sharia == true && this.is_type != null) {
        this.loading = true;
        let response = await axios({
          method: "GET",
          url: "3041?api=1&type=1&is_type=" + this.is_type + "&is_sharia=1",
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
          },
        });
        response.data.map((data) => {
          return this.products.push(data);
        });
      } else if (
        this.is_sharia == false &&
        this.is_type != null &&
        this.is_im != null
      ) {
        this.loading = true;
        let response = await axios({
          method: "GET",
          url:
            "3041?api=1&type=1&is_type=" +
            this.is_type +
            "&im_id=" +
            this.is_im,
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
          },
        });
        response.data.map((data) => {
          return this.products.push(data);
        });
      } else {
        this.loading = true;
        let response = await axios({
          method: "GET",
          url: "3041?api=1&type=1&is_sharia=1",
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
          },
        });
        response.data.map((data) => {
          return this.products.push(data);
        });
      }
      this.disabled = true;
      this.loadingTime = await 0;
    },
  },
};
</script>

<style lang="scss" scoped>
.reksadana {
  background: #f3f4f6;
}
.reksadana-page {
  background: white;
}
.reksadana-container {
  padding-top: 120px;
  padding-bottom: 60px;
  background: #f3f4f6;
}

.reksadana-product {
  background: #f3f4f6;
}

.reksadana-product-container {
  padding-bottom: 120px;
}

h1 {
  font-style: normal;
  font-weight: bold;
  font-size: 36px;
  color: #111827;
}

p {
  font-style: normal;
  font-weight: normal;
  font-size: 18px;
  color: #4b5563;
}

.con-vs-checkbox {
  justify-content: start;
  margin: 0;
}

.filter-collumn {
  background: white;
  padding-top: 50px;
  margin-top: -50px;
}

.filter-title {
  h1 {
    font-style: normal;
    font-weight: bold;
    font-size: 20px;
    color: #111827;
  }
}

.filter-fund-type {
  h2 {
    font-style: normal;
    font-weight: bold;
    font-size: 16px;
    color: #374151;
  }
}

.filter-investment-manager {
  h2 {
    font-style: normal;
    font-weight: bold;
    font-size: 16px;
    color: #374151;
  }
}

.filter-risk-profile {
  h2 {
    font-style: normal;
    font-weight: bold;
    font-size: 16px;
    color: #374151;
  }
}

.filter-minimum-buy {
  h2 {
    font-style: normal;
    font-weight: bold;
    font-size: 16px;
    color: #374151;
  }
}

.filter-sharia {
  input[type="checkbox"],
  input[type="radio"] {
    box-sizing: border-box;
    padding: 0;
    border-color: $secondaryColor !important;
    background-color: $secondaryColor !important;
  }
  .active {
    color: white;
    border-color: $secondaryColor !important;
    background-color: $secondaryColor !important;
  }

  h2 {
    font-style: normal;
    font-weight: normal;
    font-size: 16px;
    color: #111827;
  }
}

.product-collumn {
  padding-left: 40px;
  padding-right: 40px;
}

.card-body {
  padding: 8px;
}

.search-form {
  text-align: right;
  .form-control {
    outline: none !important;
    border: none !important;
    box-shadow: none !important;
  }
}

.form-control:focus {
  outline: none !important;
  border: none !important;
  box-shadow: none !important;
}

.list-product-title {
  h1 {
    font-style: normal;
    font-weight: bold;
    font-size: 24px;
    color: #111827;
  }
  span {
    font-style: normal;
    font-weight: normal;
    font-size: 14px;
    color: #6b7280;
  }
}

.card-body {
  padding: 8px;
}

.list-product {
  padding-bottom: 92px;
}

.product-tabs {
  padding-top: 20px;
}

.nav-link {
  font-family: $inter;
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  background: #f7f7f8;
  color: #4b5563;
  padding: 10px 12px 10px 12px;
  box-sizing: border-box;
  border-radius: 4px;
}

.nav-link:hover {
  background: #fcddd9;
  color: #5e1108;
}

.nav-item {
  padding: 0px 8px 0px 8px;
}
.noborder {
  border: none;
}

.table-product {
  padding-top: 16px;
  margin-left: 8px;
}

thead {
  background: #f9fafb;
}

.table-striped tbody tr:nth-of-type(odd) {
  background: #f9fafb;
}

table th {
  font-family: $inter;
  font-style: normal;
  font-weight: bold;
  font-size: 14px;
  color: #4b5563;
}

table a {
  font-family: $inter;
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  color: #5c0dab;
  text-decoration: none;
}

table td {
  font-family: $inter;
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  color: #111827;
}

table td p {
  font-family: $inter;
  font-style: normal;
  font-weight: normal;
  font-size: 12px;
  color: #6b7280;
}

table {
  border: none !important;
  border-collapse: separate !important;
  border-spacing: 0 !important;
}
table tr th,
table tr:first-child th:first-child {
  border-top-left-radius: 0.25rem !important;
}

table tr:first-child th:last-child {
  border-top-right-radius: 0.25rem !important;
}

table tr:last-child td:first-child {
  border-bottom-left-radius: 0.25rem !important;
}

table tr:last-child td:last-child {
  border-bottom-right-radius: 0.25rem !important;
}

.borderless th,
.borderless tr {
  border: none !important;
}

.table > tbody > tr > td {
  vertical-align: middle;
}

tr {
  border: none !important;
}

.product-image {
  border-radius: 6px;
  width: 40px;
}

.customPagination > li > a {
  color: white;
}

.customPagination > li.active > a,
.customPagination > li > a:hover {
  color: white;
  background-color: $primaryColor !important;
}

.disclaimer {
  .card {
    background: #ebf8ff;
    border: 1px solid #90cdf4;
    box-shadow: 0px 1px 2px rgba(107, 114, 128, 0.06),
      0px 1px 3px rgba(107, 114, 128, 0.1);
    border-radius: 6px;
  }
  p {
    font-family: $inter;
    font-style: normal;
    font-weight: normal;
    font-size: 16px;
    color: #2c5282;
    margin: 0px;
  }
}

.buy-product a {
  text-decoration: none;
}

.buy-product a:focus {
  color: white !important;
}

.buy-product a:active {
  color: white !important;
}

@media only screen and (max-width: 768px) {
  h1 {
    font-size: 24px !important;
  }
  h1 {
    font-size: 18px !important;
  }
  .filter-collumn {
    background: white;
    padding-top: 50px;
    margin-top: -50px;
    padding: 40px;
    margin-bottom: 50px;
  }
  .search-form-row {
    margin: 20px 20px;
    justify-content: center !important;
  }
  .search-icon {
    display: none;
  }
}

@media only screen and (min-width: 1366px) {
  .reksadana-container {
    padding-bottom: 500px;
  }
}
</style>
